module.exports = "https://static.zego.com/_next/static/images/ZegoIsTrustedAriel-49d3d9b96414aec20fc36ba4e8bc4b60.png";